export const decodeJWT = (token) => {
    if (!token) return null;

    const payload = token.split('.')[1];

    try {
        return JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
    } catch (err) {
        console.error("Invalid token", err);
        return null;
    }
};